import React from 'react';

import List from "components/List";
import ShippingMethodList from "./components/ShippingMethodList";

function ShippingMethods(props) {
    return (
        <List title={'shippingMethods.title'}>
            <ShippingMethodList />
        </List>
    )
}

export default ShippingMethods;
